module.exports = __webpack_public_path__ + "img/Contractp-End.363ac5a7.svg";